[<AutoOpen>]
module PromiseImpl

let promise = Promise.PromiseBuilder()